/**
 * Created by Allan on 2022/09/06.
 * Contact 84880528@qq.com.
 * 支付结果返回成功或失败
 */
import Vue from 'vue'
import App from './App'
import Vant from 'vant'
import 'vant/lib/index.css'
import router from '@/statepayment/router/'

Vue.use(Vant);
Vue.config.productionTip = false

new Vue({
    el:'#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/statepayment/main.js